/**
 * Heritage, from one place only.
 *
 * Supratechnic Pte Ltd was incorporated in 1968 — Annual Report 2026, p.1
 * ("Since 1968") and p.4 ("The heritage of these businesses goes back to 1968").
 * As at 2026 that is 58 years.
 *
 * `HERITAGE_YEARS` is stated, not derived from the clock: a published figure in
 * a listed issuer's copy must change when the Company says so, not silently on
 * 1 January. Review it with the next Annual Report.
 *
 * Every heritage mention on the site interpolates these constants. There must be
 * no literal year count in copy, JSX, meta tags, alt text, JSON-LD or the stat
 * counter — the previous figure survived for months because it had been typed
 * into nine places across three locales.
 */
export const HERITAGE_SINCE = 1968;
export const HERITAGE_YEARS = 58;
